module.exports = __webpack_public_path__ + "static/media/ybk.c78d38d5.png";